(() => {
  const SELECTORS = {
    link: '[data-uis24-load-more-link]',
    root: '[data-uis24-load-more]',
    grid: '#product-grid',
    status: '[data-uis24-order-status], .uis24-stock',
  };

  const normalizeStatusLabels = (root = document) => {
    root.querySelectorAll(SELECTORS.status).forEach((status) => {
      const label = status.textContent.trim();

      if (label === 'Beim Lieferpartner bestellbar' || label === 'Bei uns bestellbar') {
        status.textContent = 'Direkt bei uns bestellbar';
      }
    });
  };

  const setLoadingState = (link, isLoading) => {
    const label = link.querySelector('[data-uis24-load-more-label]');

    link.classList.toggle('is-loading', isLoading);
    link.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    link.setAttribute('aria-disabled', isLoading ? 'true' : 'false');

    if (label) {
      label.textContent = isLoading ? 'Produkte werden geladen ...' : 'Mehr Produkte anzeigen';
    }
  };

  const appendProducts = (currentGrid, nextGrid) => {
    const fragment = document.createDocumentFragment();
    const items = [...nextGrid.children];

    items.forEach((item) => fragment.appendChild(document.importNode(item, true)));
    normalizeStatusLabels(fragment);
    currentGrid.appendChild(fragment);

    return items.length;
  };

  const refreshAppendedProducts = (currentGrid, addedCount) => {
    window.UIS24Wishlist?.updateWishlistButtons?.(currentGrid);

    if (typeof window.initializeScrollAnimationTrigger === 'function') {
      window.initializeScrollAnimationTrigger();
    }

    document.dispatchEvent(new CustomEvent('uis24:catalog:products-loaded', {
      detail: { addedCount },
    }));
  };

  normalizeStatusLabels();

  document.addEventListener('click', async (event) => {
    const link = event.target.closest(SELECTORS.link);
    if (!link) return;

    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;

    const loadMore = link.closest(SELECTORS.root);
    const currentGrid = document.querySelector(SELECTORS.grid);
    if (!loadMore || !currentGrid) {
      window.location.assign(link.href);
      return;
    }

    setLoadingState(link, true);

    try {
      const nextUrl = new URL(link.href, window.location.origin);
      nextUrl.searchParams.set('section_id', loadMore.dataset.sectionId);

      const response = await fetch(nextUrl.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = documentFragment.querySelector(SELECTORS.grid);
      const nextLoadMore = documentFragment.querySelector(SELECTORS.root);

      if (!nextGrid) throw new Error('Produktgrid fehlt in der Antwort.');

      const addedCount = appendProducts(currentGrid, nextGrid);
      if (nextLoadMore) {
        loadMore.replaceWith(document.importNode(nextLoadMore, true));
      } else {
        loadMore.remove();
      }

      refreshAppendedProducts(currentGrid, addedCount);
    } catch (error) {
      console.error('Weitere Produkte konnten nicht geladen werden.', error);
      setLoadingState(link, false);

      const label = link.querySelector('[data-uis24-load-more-label]');
      if (label) label.textContent = 'Erneut versuchen';
    }
  });
})();
